import React from "react";

import ColumnsOffset from "./ColumnsOffset";

type RowResultsProps = {
  children: React.ReactNode;
};

const RowResults: React.FC<RowResultsProps> = ({ children }) => {
  return (
    <div className="row">
      <ColumnsOffset col="22" offset="1">
        {children}
      </ColumnsOffset>
    </div>
  );
};

export default RowResults;
